import Vue from 'vue';
import './plugins/fontawesome';
import App from './App.vue';
import router from './router/Router.js';
import * as VueGoogleMaps from 'vue2-google-maps';
import Notifications from 'vue-notification';
import DisableAutocomplete from 'vue-disable-autocomplete';
import instagram from './assets/instagram';
import website from './assets/website';
import StringExtensions from "./Auxiliares/StringExtensions";
import Clases from "./Auxiliares/Clases";
import VueConfirmDialog from 'vue-confirm-dialog';
// import 'bootstrap/dist/css/bootstrap.min.css';

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCl8g0sZTklDjUqlMRo_S0PF4oVWkzWuk8'
    },
});

console.log(`Versión: ${process.env.VUE_APP_VERSION}`);
Vue.mixin({
    computed: {
        urlPosts() {
            return process.env.VUE_APP_API_URL;
        }
    }
})

Vue.use(Notifications);
Vue.use(DisableAutocomplete);
Vue.use(VueConfirmDialog);
Vue.use(StringExtensions);
// Vue.use(UrlPosts);
Vue.use(Clases);//TODO: chequear porque creo que no funciona
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.component('instagram', instagram);
Vue.component('website', website);

//#region Importamos componentes globales
import Titulo from "./components/Titulo.vue";
import Descripcion from "./components/Descripcion.vue";
import Tabla from "./components/Tabla.vue";
import BotonVerMapa from "./components/BotonVerMapa.vue";
import PdfTable from "./components/PdfTable.vue";
import Loader from "./components/globals/Loader";
Vue.component('Titulo', Titulo);
Vue.component('Descripcion', Descripcion);
Vue.component('Tabla', Tabla);
Vue.component('BotonVerMapa', BotonVerMapa);
Vue.component('PdfTable', PdfTable);
Vue.component('Loader', Loader);
import vuePdf from 'vue-pdf';
Vue.component('vue-pdf', vuePdf)
//#endregion



new Vue({
    router,
    render: function (h) {
        return h(App);
    }
}).$mount("#app");

//#region "PWA"
window.onload = function () {
    PWAControls();
}
var newWorker;
async function PWAControls() {
    if ('serviceWorker' in navigator) {
        var swPath = process.env.NODE_ENV === "production" ? '/agroideas-maizplus/sw.js' : './sw.js';
        navigator.serviceWorker.register(swPath)
            .then(reg => {
                console.log('Service worker registered!');
                if (PWAInstalled()) {
                    console.log('PWAInstalled');
                }

                reg.addEventListener('updatefound', () => {
                    newWorker = reg.installing;
                });

                reg.update();
            })
            .catch(function (e) {
                console.error('Service worker registration failed:', e);
            });

        let refreshing;
        navigator.serviceWorker.addEventListener('controllerchange', function () {
            if (refreshing) return;
            window.location.reload();
            refreshing = true;
        });
    } else {
        console.warn('Service workers are not supported.');
    }
}
function PWAInstalled() {
    // For iOS
    if (window.navigator.standalone) return true;

    // For Android
    if (window.matchMedia('(display-mode: standalone)').matches) return true;

    // If neither is true, it's not installed
    return false;
}
//#endregion



//TODO: Antes de llevar a PROD, optimizar imágenes con https://imagecompressor.com/es/
